export enum LiveDataRefreshEnum {
    WebSocket = 'WebSocket',
    SSE = 'SSE',
    LongPolling = 'LongPolling',
    RequestResponse = 'Request/Response',
  }
  